export const Header = [{
  prop: 'CABINET_ID',
  label: '柜号'
}, {
  prop: 'EQUIP_ID',
  label: '智能称编号'
}, {
  prop: 'ONLINE_STATUS',
  label: '状态'
}, {
  prop: 'TEMPERATURE',
  label: '温度'
}, {
  prop: 'HUMIDITY',
  label: '湿度'
},{
    prop: 'COMMENTS',
    label: '备注'
}]

